import { render, staticRenderFns } from "./LangBar.vue?vue&type=template&id=222e3704&"
import script from "./LangBar.vue?vue&type=script&lang=js&"
export * from "./LangBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports